import { render, staticRenderFns } from "./select-tree.vue?vue&type=template&id=4674be6d&scoped=true"
import script from "./select-tree.vue?vue&type=script&lang=js"
export * from "./select-tree.vue?vue&type=script&lang=js"
import style0 from "./select-tree.vue?vue&type=style&index=0&id=4674be6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674be6d",
  null
  
)

export default component.exports